import { useState } from "react"
import { Link, useSearchParams } from "react-router-dom"
import { SiteFooter } from "../../components/SiteFooter.js"
import { loginBackdoor, refreshAuth } from "../../lib/auth.js"
import styles from "./BackdoorLoginPage.module.css"

export function BackdoorLoginPage() {
  const [searchParams] = useSearchParams()
  const returnTo = searchParams.get("returnTo") ?? "/lists"
  const [id, setId] = useState("")
  const [password, setPassword] = useState("")
  const [error, setError] = useState<string | null>(null)
  const [pending, setPending] = useState(false)

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    setPending(true)
    setError(null)
    try {
      const ok = await loginBackdoor(id.trim(), password)
      if (!ok) {
        setError("IDまたはパスワードが正しくありません")
        return
      }
      await refreshAuth()
      const target = new URL(returnTo, window.location.origin)
      target.searchParams.set("loginSuccess", "1")
      window.location.href = target.pathname + target.search
    } catch {
      setError("ログインに失敗しました。しばらくしてから再度お試しください。")
    } finally {
      setPending(false)
    }
  }

  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <Link to="/" className={styles.backLink}>
          ← トップへ
        </Link>
      </header>

      <main className={styles.main}>
        <h1 className={styles.title}>裏口ログイン</h1>
        <p className={styles.lead}>
          プレビュー環境など OAuth コールバックが未登録のとき、マイリスト機能の確認用に使います。
        </p>

        <form className={styles.form} onSubmit={handleSubmit}>
          <label className={styles.field}>
            ID
            <input
              type="text"
              className={styles.input}
              value={id}
              onChange={(e) => setId(e.target.value)}
              autoComplete="username"
              required
            />
          </label>
          <label className={styles.field}>
            パスワード
            <input
              type="password"
              className={styles.input}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
            />
          </label>
          {error && <p className={styles.error}>{error}</p>}
          <button type="submit" className={styles.submitBtn} disabled={pending}>
            {pending ? "ログイン中..." : "ログイン"}
          </button>
        </form>
      </main>

      <SiteFooter />
    </div>
  )
}
